/* eslint-disable max-len */
import React from 'react'

import { useNavigate } from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import AnimatedList from '../../../../../../components/Animation/AnimatedList'
import moment from 'moment'
import { convertEpochToDateFormat } from '../../../../../../CommonMethods/DateConversion'

const ExportTablebody=({
    tableData,
    indexNum,
})=>{
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const fieldTOUpdate={
        'user_name':'Username',
        "field":'Field',
        "action":'Action Performed',
        "timestamp":'Time Stamp',
        "old_value":'Old Value',
        "new_value":'New Value',
        "comments":'Comments',
    }
    // const date = dateformat?.includes('AM/PM') ?
    //     moment.unix(tableData?.timestamp).utcOffset('+05:30').format(`${dateformat.split(',')[0]} h:mm:ss A`) :
    //     moment(tableData?.created_at).format(dateformat);

    const date=convertEpochToDateFormat(tableData?.created_at,dateformat)

    // const date = dateformat?.includes('AM/PM')?moment(tableData?.timestamp).utcOffset('+5:30').format(`${dateformat.split(',')[0]} h:mm:ss A`):moment(tableData?.created_at).format(dateformat)
    return(
        <>
            <AnimatedList
                id={tableData._id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <>
                        <td className="pl-[18px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {tableData?.user_name}
                        </td>

                        <td className="pl-[60px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {date}
                        </td>
                        <td className="pl-[60px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize">
                            {tableData?.filters_applied && tableData.filters_applied.length > 0 ?  (
                                <div>
                                    {tableData.filters_applied.map((item, index) => (
                                        <span key={index}>
                                            {item.replace(/_/g, ' ')}
                                            {index < tableData.filters_applied.length - 1 && ','}
                                        </span>
                                    ))}
                                </div>
                            ) : (
                                <div>-</div>
                            )}

                        </td>
                        <td className="pl-[60px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {tableData?.table_name}
                        </td>
                        <td className="pl-[60px] pr-[18px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize last_td">
                            {tableData?.exported_columns?.map((item,index)=>{
                                return(
                                    fieldTOUpdate[item] 
                                        ? fieldTOUpdate[item] + ((index!==tableData?.exported_columns.length-1)?'  ,  ':'')
                                        : (item || '').toString().replace(/_/g, " ")
                                )}
                            )
                                
                            }
                               
                        </td>
                    </>
                    
                }/>
           
        </>
    )
}

export default ExportTablebody